import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { addMonths, startOfMonth, startOfQuarter, startOfYear, endOfMonth } from 'date-fns';
import { FilterPicker, KeyboardDatePicker, MenuItem, TextField, Typography } from 'seagull';
import { DateRange } from "../types";
import { formatNumericUSDate } from "../../../../utils";
import { dateRangeOptions, dataRangeNames } from "../../RevenueBreakdown/RevenueBreakdown.utils";
import styles from "./DateRangeWithPresets.module.scss";
const DateRangeWithPresets = props => {
  const [endDate, setEndDate] = useState(props.endDate);
  const [startDate, setStartDate] = useState(props.startDate);
  const [dataRangeOption, setDataRangeOption] = useState(props.dataRangeOption || DateRange.Last12Months);
  useEffect(() => {
    const startDate = calculateStartDate(formatNumericUSDate(props.now), dataRangeOption, props.now);
    const endDate = calculateEndDate(formatNumericUSDate(props.now), dataRangeOption, props.now);
    setStartDate(startDate);
    setEndDate(endDate);
  }, [dataRangeOption]);
  return /*#__PURE__*/React.createElement(FilterPicker, {
    "data-testid": "revenue-breakdown-report-data-range-picker",
    label: dataRangeNames[dataRangeOption](startDate, endDate),
    title: "Date range",
    highlightTrigger: false,
    popoverWidth: 380,
    onApply: () => props.onApply(dataRangeOption, startDate, endDate),
    onClose: () => {}
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.row, styles.rangePicker)
  }, /*#__PURE__*/React.createElement(TextField, {
    className: styles.dataRangeDropdown,
    select: true,
    value: dataRangeOption,
    onChange: e => setDataRangeOption(e.target.value),
    testid: "revenue-breakdown-report-data-range-dropdown"
  }, dateRangeOptions.map((_ref, idx) => {
    let {
      value,
      text
    } = _ref;
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: value,
      value: value,
      "data-testid": "revenue-breakdown-report-data-range-option-".concat(idx)
    }, text);
  })), ![DateRange.AllTime, DateRange.Custom].includes(dataRangeOption) && /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "revenue-breakdown-report-data-range-helper-text",
    variant: "paragraph1",
    noWrap: true
  }, startDate, " - ", endDate)), dataRangeOption === DateRange.Custom ? /*#__PURE__*/React.createElement("div", {
    className: styles.row
  }, /*#__PURE__*/React.createElement(KeyboardDatePicker, {
    "data-testid": "revenue-breakdown-report-data-range-start-date-picker",
    className: styles.customDatePicker,
    value: startDate,
    onChange: date => {
      if (date != null) {
        setStartDate(formatNumericUSDate(date));
        if (endDate == null || date > new Date(endDate)) {
          setEndDate(formatNumericUSDate(date));
        }
      }
    },
    minDate: new Date('2023-01-01')
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph1",
    noWrap: true
  }, "\xA0-\xA0"), /*#__PURE__*/React.createElement(KeyboardDatePicker, {
    "data-testid": "revenue-breakdown-report-data-range-end-date-picker",
    className: styles.customDatePicker,
    value: endDate,
    onChange: date => date != null && setEndDate(formatNumericUSDate(date)),
    minDate: startDate
  })) : null);
};
export default DateRangeWithPresets;
export function calculateStartDate(startDate, dataRange, now) {
  switch (dataRange) {
    case DateRange.Last12Months:
      return formatNumericUSDate(addMonths(startOfMonth(now), -11));
    case DateRange.CurrentMonth:
      return formatNumericUSDate(startOfMonth(now));
    case DateRange.CurrentQuarter:
      return formatNumericUSDate(startOfQuarter(now));
    case DateRange.CurrentYear:
      return formatNumericUSDate(startOfYear(now));
    case DateRange.AllTime:
      return formatNumericUSDate(new Date('2023-01-01'));
    default:
      return startDate;
  }
}
export function calculateEndDate(endDate, dataRange, now) {
  switch (dataRange) {
    case DateRange.Last12Months:
      return formatNumericUSDate(now);
    case DateRange.CurrentMonth:
    case DateRange.CurrentQuarter:
    case DateRange.CurrentYear:
      return formatNumericUSDate(endOfMonth(now));
    case DateRange.AllTime:
      return '';
    default:
      return endDate;
  }
}